import { log } from '../../services/utils';

import { noraApiRequest } from './';

export const setDocumentModulePhoto = async ( moduleId, uid ) => {
	log( 'setDocumentModulePhoto' );
	const response = await noraApiRequest( {
		method: 'PATCH',
		url: `documentmodule/${ moduleId }/photo/${ uid }/`
	} );

	return response.data;
};
